import { Pipe, PipeTransform } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import { ConfirmationPageTextFactory } from './confirmation-page-text-factory';

@Pipe({ name: 'insertVariableToString' })
export class InsertVariableToStringPipe implements PipeTransform {

    constructor(
        private readonly _textFactory: ConfirmationPageTextFactory
    ) { }

    transform(value: string): string {
        let transformedValue = value;
        const variables = value.match(/{{(.*?)}}/g);

        if (variables?.length) {
            for (let variable of variables) {
                const variableKey = variable
                    .slice(2, -2)
                    .trim() as OLO.Types.CONFIRMATION_PAGE_VARIABLE;

                if (this._isVariableValid(variableKey)) {
                    const valueToReplace = this._textFactory.getValueByKey(variableKey);
                    transformedValue = transformedValue.replace(variable, valueToReplace);
                }

            }
        }

        return transformedValue;
    }

    private _isVariableValid(valueToCheck: string): valueToCheck is OLO.Types.CONFIRMATION_PAGE_VARIABLE {

        const POSSIBLE_VARIABLES: OLO.Types.CONFIRMATION_PAGE_VARIABLE[] = [
            'orderNumber',
            'locationName',
            'pickupDate',
            'orderTypeName',
            'orderTypeDetails',
            'orderTypeDetailValue',
            'locationAddress',
        ];

        if (POSSIBLE_VARIABLES.findIndex(el => el === valueToCheck) !== -1) {
            return true;
        } else {
            console.error(
                `
                INCORRECT VARIABLE: ${valueToCheck}
                Incorrect variable has been provided. Please check if config.js doesn\`t have any typo
                or if POSSIBLE_VARIABLES has all members of OLO.Types.CONFIRMATION_PAGE_VARIABLE in _isVariableValid() type guard`
            );

            return false;
        }

    }
}
